module.exports = __webpack_public_path__ + "fonts/b5URToY9.woff2";